module.exports = __webpack_public_path__ + "static/news4-4-b169387ae36f445d77fa63f37758311a.jpg";